$(document).ready(function (){
    $('.collection-product').each(function(){
    // $(this).find('.swatch-select').each(function (){
    //   $(this).val($(this).find('option:first').val());  
    // });
    $(this).find('.swatch-color').each(function (){
      $(this).find('.swatch-input-1').prop('checked', true);
    });
  });
  
  $(document).on('change', '.swatch-select, .swatch-input', function() {
    selectSwatches(this);
  });
});
var Shopify = Shopify || {};
// // ---------------------------------------------------------------------------
// // Money format handler
// // ---------------------------------------------------------------------------
// Shopify.money_format = "${{amount}}";
  function formatMoney(cents, format) {
		  		if (typeof cents == 'string') { cents = cents.replace('.', ''); }
		  		var value = '';
		  		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		  		var formatString = (format || Shopify.money_format);

		  		function defaultOption(opt, def) {
		  		  return (typeof opt == 'undefined' ? def : opt);
		  		}

		  		function formatWithDelimiters(number, precision, thousands, decimal) {
		  		  precision = defaultOption(precision, 2);
		    		thousands = defaultOption(thousands, ',');
		    		decimal = defaultOption(decimal, '.');

		    		if (isNaN(number) || number == null) { return 0; }

		    		number = (number / 100.0).toFixed(precision);

		    		var parts = number.split('.'),
		    		  dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
		    		  cents = parts[1] ? (decimal + parts[1]) : '';

		    		return dollars + cents;
		  		}

		  		var match = formatString.match(placeholderRegex);

		  		if (match) {
		    			switch (match[1]) {
		      	case 'amount':
		      	  value = formatWithDelimiters(cents, 2);
		      	  break;
		      	case 'amount_no_decimals':
		      	  value = formatWithDelimiters(cents, 0);
		      	  break;
		      	case 'amount_with_comma_separator':
		      	  value = formatWithDelimiters(cents, 2, '.', ',');
		      	  break;
		      	case 'amount_no_decimals_with_comma_separator':
		      	  value = formatWithDelimiters(cents, 0, '.', ',');
		      	  break;
					  case "amount_with_apostrophe_separator":
		      	  value = formatWithDelimiters(cents, 2, "'", ".");
		      	  break;
		   				 }
		  		}

		  		return formatString.replace(placeholderRegex, value);
			};
function selectSwatches(element) {
  let productItem = $(element).closest('.product-grid-item');
  let productForm  = $(element).closest('form');

  let optionsArray = [];
  productForm.find('.swatch-variant').each(function (){
    if ($(this).is(':selected') || $(this).is(':checked')) {
      optionsArray.push($(this).val());
    }
  });

  let variantName = optionsArray.join(' / ');
  let selectedVaraint;
  
  productForm.find('.product-variant-select option').each(function() {
    if($(this).text() == variantName) {
      selectedVaraint = $(this);
      console.log(selectedVaraint)
      let variantPrice = formatMoney(selectedVaraint.data('price'), '${{amount}}');
      console.log(variantPrice)
      if(variantPrice != "$0"){
          variantPrice = variantPrice.slice(0, -3); 
      }       
      productItem.find('.product-price').text(variantPrice);
    }
  });
  
  if(typeof selectedVaraint != 'undefined') {
    let buttonText = selectedVaraint.data('btn-text');
    let variantValue = selectedVaraint.val();
    productForm.find('input[name="id"]').val(variantValue);
    productForm.find('.product-variant-select').val(variantValue);
    let imageSrc = selectedVaraint.data('image');
    productItem.find('.grid-view-item__image').removeAttr('data-srcset srcset').removeClass('lazyloaded lazyautosizes').addClass('lazyload');
    productItem.find('.grid-view-item__image').attr('data-src', imageSrc);
    if(buttonText == 'Sold out') {
      productForm.find('.add-to-cart').prop('disabled', true);
    } else {
      productForm.find('.add-to-cart').prop('disabled', false);
    }
    
    if(buttonText == 'Pre-order') {
      if(productForm.find('.preorder-line-item').length == 0) {
        productForm.find('.add-to-cart').before('<input type="hidden" name="properties[_is_preorder]" value="Pre-order item" class="preorder-line-item">');
      }
    } else {
      productForm.find('.preorder-line-item').remove();
    }
    
    productForm.find('.add-to-cart span').text(buttonText);
  } else {
    productForm.find('.add-to-cart').prop('disabled', true);
    productForm.find('.add-to-cart span').text('Unavailable');
  }
   
}